import { Component, OnInit } from '@angular/core';
import {AppService} from '../../appService';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Toast, ToastsManager} from 'ng2-toastr';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-tutor-student-lookup',
  templateUrl: './tutor-student-lookup.component.html',
  styleUrls: ['./tutor-student-lookup.component.css']
})
export class TutorStudentLookupComponent implements OnInit {

  studentId: any;
  imagePath: any;
  isShowData: boolean;
  studentDetails: any = {};
  singleStudentResultSummery: any = {};
  singleStudentPaymentLedgerSummery: any = {};
  singleStudentSgpaList: any = [];
  brifDescription: any = '';
  personalInterest: any = '';
  initialProblem: any = '';
  strangthOfStudent: any = '';
  weaknessOfStudent: any = '';
  additionalInfoOfStudent: any = '';
  singleStudentPaymentHistory: any = {};
  singleStudentCounsellingHistory: any = {};
  singleStudentProctorialCounsellingHistory: any = {};
  semesterList: any = [];
  semesterIdToSearchSingleStudentResultDetails = '';
  singleStudentResultDetailsList: any = [];
  singleStudentResultList: any = [];
  semesterIdToSearchSingleStudentResult = '';
  semesterIdToSearchSingleStudentAttendance = '';
  attendanceList: any = [];
  summaryResultCourseCodeOrTitleFilter: any = '';
  detailsResultCourseCodeOrTitleFilter: any = '';
  attendanceCourseCodeOrTitleFilter: any = '';
  constructor(private appService: AppService, private httpClient: HttpClient, public toastr: ToastsManager) {
  }

  ngOnInit() {

  }

  getStudentInfo() {
    this.isShowData = true;
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/v3/singleStudentDetails',
      {headers: this.appService.getHeadersWithAccessToken(), params: myParams})
      .subscribe((res: any ) => {
          // console.log(res);
          if (res.status === true) {
            this.toastr.success('Student Details Found!!', 'Success!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000);         });
            this.studentDetails = res.data;
            this.imagePath = 'data:image/jpeg;base64,' + this.studentDetails.photo.studentPhoto;
            // localStorage.setItem('stdIdForStdLookup', this.studentDetails.studentId);

            this.isShowData = false;
            this.getSingleStudentResultSummery(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            // this.getSingleStudentPaymentLedgerSummery(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            this.getSingleStudentSgpaList(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            // this.getSingleStudentObservation(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            // this.getSingleStudentPaymentHistory(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            this.getSemesterList();
            // this.getSingleStudentCounsellingHistory(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
            // this.getSingleStudentProctorialCounsellingHistory(this.studentDetails.STUDENT_ID != null ? this.studentDetails.STUDENT_ID : null);
          } else {
            console.log(res.status);
            this.studentDetails = {};
            this.toastr.error('Student Details Found!!', 'Oops!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000);         });
            this.isShowData = false;
          }
        },
        msg => {
          this.isShowData = false;
          this.toastr.error('Data Not Found');
          this.toastr.error('Data Not Found', 'Oops!', {dismiss: 'click', showCloseButton: false, animate: 'flyLef'})
            .then((toast: Toast) => { setTimeout(() => {this.toastr.dismissToast(toast); }, 2000);
            });
        }
      );
  }

  isNotEmpty(obj: any): boolean {
    return Object.keys(obj).length !== 0;
  }

  getSingleStudentResultSummery(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentResultSummery', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultSummery = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'panelAccess/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.semesterList = res;
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentPaymentHistory(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentRecentPayment', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentPaymentHistory = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }
  getSingleStudentCounsellingHistory(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentCounselling', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentCounsellingHistory = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }
  getSingleStudentProctorialCounsellingHistory(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentProctorialCounselling', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentProctorialCounsellingHistory = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }
  getSingleStudentPaymentLedgerSummery(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentPaymentLedgerSummery', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentPaymentLedgerSummery = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentSgpaList(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentSgpaList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentSgpaList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }

  getSingleStudentObservation(studentId) {
    const myParams = new HttpParams().append('studentId', studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/v2/singleStudentObservation', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe((res: any) => {
          // console.log(res.brifDescription);

          this.brifDescription = res.brifDescription;
          this.personalInterest = res.personalInterest;
          this.initialProblem = res.initialProblem;
          this.strangthOfStudent = res.strangthOfStudent;
          this.weaknessOfStudent = res.weaknessOfStudent;
          this.additionalInfoOfStudent = res.additionalInfoOfStudent;
        },
        msg => {
          console.error('error');
        }
      );
  }
  getSingleStudentResultDetailsList() {

    const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentResultDetails).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentResultDetailsList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultDetailsList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }


  getSingleStudentResultList() {

    const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentResult).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentResultList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          this.singleStudentResultList = res;
          // console.log(res);
        },
        msg => {
          console.error('error');
        }
      );
  }



  // getAttendanceList() {
  //   const myParams = new HttpParams().append('semesterId', this.semesterIdToSearchSingleStudentAttendance).append('studentId', this.studentId);
  //   this.httpClient.get(environment.apiUrl + 'panelAccess/singleStudentAttendanceList', {
  //     headers: this.appService.getHeadersWithAccessToken(),
  //     params: myParams
  //   })
  //     .subscribe(res => {
  //         this.attendanceList = res;
  //         // console.log(res);
  //       },
  //       msg => {
  //         console.error('error');
  //       }
  //     );
  // }

  // getPresentAttendanceTotal(attendance) {
  //   let count = 0;
  //   const objectKey = Object.keys(attendance);
  //   for (let i = 0; i < objectKey.length; i++) {
  //     if (objectKey[i].startsWith('A')) {
  //       const paramValue = attendance[objectKey[i]];
  //       if (paramValue) { count += 1; }
  //     }
  //   }
  //   return count;
  // }


}
